/**
 * @param {string} country
 * @param {string|null} referer
 * @returns {{brokerId: number, adId: number, affId: number}}
 */
function setOrganicTracking ({ country, referer = null } = {}) {
  const values = {
    brokerId: 0,
    affId: 0,
    adId: 0
  }

  if (!country || !referer) return values

  const ids = {
    se: {
      google: 172,
      yahoo: 174,
      bing: 177,
      msn: 173,
      live: 175,
      altavista: 176,
      eniro: 362,
      ask: 363
    },
    no: {
      google: 115,
      yahoo: 44,
      bing: 244,
      kvasir: 110,
      startsiden: 121,
      ask: 363
    },
    fi: {
      google: 172,
      yahoo: 174,
      bing: 177,
      ask: 363
    }
  }

  if (referer.match(/google/i) && !referer.match(/googleadservices/i)) {
    values.brokerId = ids[country]?.google
  } else if (referer.match(/yahoo/i, referer)) {
    values.brokerId = ids[country]?.yahoo
  } else if (referer.match(/bing/i, referer)) {
    values.brokerId = ids[country]?.bing
  } else if (referer.match(/kvasir/i, referer)) {
    values.brokerId = ids[country]?.kvasir
  } else if (referer.match(/startsiden/i, referer)) {
    values.brokerId = ids[country]?.startsiden
  } else if (referer.match(/ask/i, referer)) {
    values.brokerId = ids[country]?.ask
  } else if (referer.match(/msn/i, referer)) {
    values.brokerId = ids[country]?.msn
  } else if (referer.match(/live/i, referer)) {
    values.brokerId = ids[country]?.live
  } else if (referer.match(/altavista/i, referer)) {
    values.brokerId = ids[country]?.altavista
  } else if (referer.match(/eniro/i, referer)) {
    values.brokerId = ids[country]?.eniro
  }

  return values
}

module.exports = { setOrganicTracking }
